// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter_counter__Ghtrl","count":"counter_count__mgp5L","button":"counter_button__scgy_"};